import { Entity } from './Entity';
import { World } from './World';

/**
 * System - Contains game logic
 * Systems operate on entities that have specific components
 */
export abstract class System {
  /**
   * Component types required for this system to process an entity
   * Override in subclass to specify required components
   */
  public abstract readonly requiredComponents: string[];

  /**
   * Whether this system is enabled
   */
  public enabled = true;

  /**
   * Reference to the ECS world
   */
  protected world!: World;

  /**
   * Set the world reference (called by World.addSystem)
   */
  public setWorld(world: World): void {
    this.world = world;
  }

  /**
   * Called when the system is added to the world
   * Override to perform initialization
   */
  public init(): void {
    // Override in subclass
  }

  /**
   * Called every frame with entities matching requiredComponents
   * @param entities Entities with all required components
   * @param delta Time since last frame in milliseconds
   */
  public abstract update(entities: Entity[], delta: number): void;

  /**
   * Called when an entity with matching components is added
   * Override to handle entity addition
   */
  public onEntityAdded(_entity: Entity): void {
    // Override in subclass
  }

  /**
   * Called when an entity with matching components is removed
   * Override to handle entity removal
   */
  public onEntityRemoved(_entity: Entity): void {
    // Override in subclass
  }

  /**
   * Called when the system is removed from the world
   * Override to perform cleanup
   */
  public destroy(): void {
    // Override in subclass
  }
}
